import _taggedTemplateLiteral from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import propsToCss from '../utils/propsToCss';
const RouterLink = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), props => propsToCss(props));
export { RouterLink };